import {AfterViewInit, ChangeDetectionStrategy, Component, inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {environment} from '@env/environment';

@Component({
  selector: 'app-trustpilot-mini-widget',
  templateUrl: './trustpilot-mini-widget.component.html',
  styleUrls: ['./trustpilot-mini-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class TrustpilotMiniWidgetComponent implements AfterViewInit {
  private readonly platformId = inject(PLATFORM_ID);
  
  /**
   * Show Trustpilot widget based on environment configuration
   */
  readonly showWidget = environment.trustpilot?.enabled ?? false;
  
  /**
   * Widget configuration from environment
   */
  readonly widgetConfig = environment.trustpilot?.widgets.mini ?? {};
  readonly locale = environment.trustpilot?.locale ?? 'da-DK';
  readonly businessunitId = environment.trustpilot?.businessunitId ?? '';
  readonly reviewPageUrl = environment.trustpilot?.reviewPageUrl ?? '';
  
  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId) && this.showWidget) {
      this.loadTrustpilotWidget();
    }
  }
  
  private loadTrustpilotWidget(): void {
    // Load Trustpilot script if not already loaded
    if (!document.getElementById('trustpilot-widget-script')) {
      const script = document.createElement('script');
      script.id = 'trustpilot-widget-script';
      script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      script.async = true;
      document.head.appendChild(script);
      
      script.onload = () => {
        this.refreshWidget();
      };
    } else {
      // Script already loaded, just refresh the widget
      this.refreshWidget();
    }
  }
  
  private refreshWidget(): void {
    // Trustpilot provides a global function to reload widgets
    const trustpilot = (window as any).Trustpilot;
    if (trustpilot && trustpilot.loadFromElement) {
      const trustboxElements = document.querySelectorAll('.trustpilot-widget');
      trustboxElements.forEach(element => {
        trustpilot.loadFromElement(element, true);
      });
    }
  }
}
